// @ts-nocheck
// Exact live (2026-10-15) version restored from the production sourcemap.
import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime';
import { Box, Grid, IconButton, Typography } from '@mui/material';
import { ArrowLeft } from 'iconsax-react';
import { useNavigate } from 'react-router-dom';
export const PageHeader = ({ title, children, goback, startComponent, leftComponent }) => {
    const navigate = useNavigate();
    const goBack = () => {
        navigate(-1);
    };
    return _jsx(Box, {
        sx: { mb: { xs: 5, md: 3 } },
        children: _jsxs(Grid, {
            container: true,
            spacing: 2,
            children: [
                _jsx(Grid, {
                    item: true,
                    md: 6,
                    sm: 6,
                    xs: 12,
                    children: _jsxs(Box, {
                        display: 'flex',
                        gap: 2,
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        children: [
                            goback &&
                                _jsx(IconButton, {
                                    sx: { border: '1px solid #D7D7D7' },
                                    onClick: goBack,
                                    'aria-label': 'Go back',
                                    children: _jsx(ArrowLeft, {})
                                }),
                            leftComponent,
                            _jsx(Typography, {
                                variant: 'h3',
                                component: 'h1',
                                fontWeight: 500,
                                color: 'initial',
                                children: title
                            }),
                            startComponent
                        ]
                    })
                }),
                _jsx(Grid, {
                    item: true,
                    md: 6,
                    sm: 6,
                    xs: 12,
                    children: _jsx(Box, {
                        sx: {
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: 2
                        },
                        children: children
                    })
                })
            ]
        })
    });
};
{
    /* <Box>
<Box
  display={"flex"}
  sx={{ justifyContent: "space-between" }}
  alignItems={"center"}
  mb={10}
>
  <Box display={"flex"} gap={2} alignItems={"center"}>
    {goBack && (
      <IconButton sx={{ border: "1px solid #D7D7D7" }} onClick={goBack}>
        <ArrowLeft />
      </IconButton>
    )}
    <Typography variant="h3" fontWeight={500} color="initial">
      {title}
    </Typography>
  </Box>
  {children}
</Box>
</Box> */
}
